import "./App.css";

import SmoothScroll from "smooth-scroll";

// Main Site Pages
import HomePage from "./main-site-pages/HomePage.js";
import LoginPortal from "./main-site-pages/login/LoginPortal.jsx";
import UnderConstruction from "./main-site-pages/UnderConstruction.js";
import ResetPassword from "./main-site-pages/login/ResetPassword.jsx";
import SubscriptionOnboarding from "./main-site-pages/SubscriptionOnboarding.jsx";
import FreeTrialRegistration from "./main-site-pages/misc/FreeTrialRegistration.jsx";
import ACT2026Registration from "./main-site-pages/misc/ACT2026Registration.jsx";
import NotFoundPage from "./main-site-pages/NotFoundPage.jsx";
import LogoPreview from "./main-site-pages/LogoPreview.jsx";
import LogoPreviewRound2 from "./main-site-pages/LogoPreviewRound2.jsx";
import ACTFreeTrialRedirect from "./main-site-pages/misc/ACTFreeTrialRedirect.jsx";
import EmailVerificationPage from "./main-site-pages/login/EmailVerificationPage.jsx";
import Products from "./main-site-pages/Products.jsx";
import Contact from "./main-site-pages/Contact.jsx";
import Resources from "./main-site-pages/Resources.jsx";
import TermsAndConditions from "./main-site-pages/TermsAndConditions.jsx";
import PrivacyPolicy from "./main-site-pages/PrivacyPolicy.jsx";
import SubscriptionConfirmation from "./main-site-pages/SubscriptionConfirmation.js";

// Main App Pages (Logged in users)
import LoginLanding from "./main-site-pages/main-app/LoginLanding.jsx";

// Main Page Layout
import MainLayout from "./components/layout/MainLayout.jsx";
import AppLayout from "./components/layout/AppLayout.jsx";
import PublishedForecastLayout from "./components/layout/PublishedForecastLayout.jsx";
import {
  chargerNavConfig,
  dataHubNavConfig,
  fleetNavConfig,
  internalOpsNavConfig,
  regulatorNavConfig,
  sageNavConfig,
  utilityNavConfig,
} from "./config/sidebarNavConfigs";

// Site Info Pages
import FleetOwners from "./main-site-pages/solutions-info/FleetOwners.jsx";
import ChargerDevelopers from "./main-site-pages/solutions-info/ChargerDevelopers.jsx";
import Regulators from "./main-site-pages/solutions-info/Regulators.jsx";
import Utilities from "./main-site-pages/solutions-info/Utilities.jsx";
import GridPlanPlanArticle from "./main-site-pages/news/GridPlanPlanArticle.jsx";

// Apps
import BasicCalculator from "./apps/fleet_planning/basicCalculator.js";

// Pro Calculator / Fleet Planning
import FleetPlanningDashboard from "./apps/fleet_planning/fleetPlanningDashboard.js";
import Profile from "./main-site-pages/profile.js";
import TechnicalDetails from './components/pro_calculator/general/TechnicalDetails.jsx';
import UserManual from './components/pro_calculator/general/UserManual.jsx';

// Charger Planning
import ChargerPlanningDashboard from "./apps/charger_planning/chargerPlanningDashboard.js";
import ChargerMapView from "./apps/charger_planning/chargerMapView.js";
import ChargerTableView from "./apps/charger_planning/chargerTableView.js";
import ChargerUserManual from "./components/charger_planning/ChargerUserManual.jsx";
import ChargerTechnicalDetails from "./components/charger_planning/ChargerTechnicalDetails.jsx";
import SageMapPage from "./apps/sage/SageMapPage.jsx";

// Utility Planning
import UtilityPlanningDashboard from "./apps/utility_planning/utilityPlanningDashboard.js";
import UtilityTableView from "./apps/utility_planning/utilityTableView.js";
import UtilityScenarioStudy from "./apps/utility_planning/utilityScenarioStudy.js";
import UtilityScenarioCaseListPage from "./apps/utility_planning/utilityScenarioCaseListPage.js";
import UtilityScenarioCaseDetailPage from "./apps/utility_planning/utilityScenarioCaseDetailPage.js";
import UtilityLatestResultRedirect from "./apps/utility_planning/UtilityLatestResultRedirect.js";
import StateUtilitySelector from "./components/utility_planning/StateUtilitySelector.jsx";
import UtilityProactivePlanning from "./apps/utility_planning/utilityProactivePlanning.js";
import UtilityWorkflow from "./apps/utility_planning/utilityWorkflow.jsx";
import PassengerEvAdoptionTrendPage from "./apps/utility_planning/systemModels/PassengerEvAdoptionTrendPage.jsx";
import PassengerEvZctaAdoptionTrendPage from "./apps/utility_planning/systemModels/PassengerEvZctaAdoptionTrendPage.jsx";
import MdhdEvAdoptionTrendPage from "./apps/utility_planning/systemModels/MdhdEvAdoptionTrendPage.jsx";
import {
  RatePlanInputPage,
  ManagedChargingInputPage,
  VehiclePricingInputPage,
  VehicleConfigurationInputPage,
  PolicyInputPage,
  ChargingInfraInputPage,
  SeasonWeatherInputPage,
  DemographicsInputPage,
  TravelSurveyInputPage,
  EvChargingBehaviorInputPage,
} from "./apps/utility_planning/workflowInputs";
import UtilityVehicleSimulation from "./apps/utility_planning/utilityVehicleSimulation.js";
import CaStatewiseCasePage from "./apps/utility_planning/CaStatewiseCasePage.jsx";
import CaStatewideTechnicalDetails from "./apps/utility_planning/CaStatewideTechnicalDetails.jsx";
import CaTransitCasePage from "./apps/utility_planning/CaTransitCasePage.jsx";

// Changelog
import ChangelogPage from "./components/changelog/ChangelogPage.jsx";
import {
  fleetChangelog,
  chargerChangelog,
  utilityChangelog,
  regulatorChangelog,
  dataHubChangelog,
} from "./config/changelogData";

// Data Hub
import DataHubHome from "./apps/data_hub/DataHubHome.jsx";
import InternalOpsUsers, { InternalOpsUserDetail } from "./apps/internal_ops/InternalOpsUsers.jsx";
import InternalOpsApiUsage, {
  InternalOpsApiUsageApp,
  InternalOpsApiUsageEndpoint,
} from "./apps/internal_ops/InternalOpsApiUsage.jsx";
import InternalOpsDatabase, {
  InternalOpsDatabaseApp,
  InternalOpsDatabaseTable,
} from "./apps/internal_ops/InternalOpsDatabase.jsx";
import InternalOpsTraffic from "./apps/internal_ops/InternalOpsTraffic.jsx";
import InternalOpsLoginMap from "./apps/internal_ops/InternalOpsLoginMap.jsx";
import InternalOpsParcelPopularity from "./apps/internal_ops/InternalOpsParcelPopularity.jsx";
import RateListPage from "./apps/data_hub/RateListPage.jsx";
import RateDetailPage from "./apps/data_hub/RateDetailPage.jsx";
import TerritoryMapView from "./apps/data_hub/TerritoryMapView.jsx";
import ChargingStationMapView from "./apps/data_hub/ChargingStationMapView.jsx";
import VehicleModelListPage from "./apps/data_hub/VehicleModelListPage.jsx";
import RegulatorMapView from "./apps/regulator/RegulatorMapView.jsx";
import RegulatorTableView from "./apps/regulator/RegulatorTableView.jsx";
import RegulatorTechnicalDetails from "./components/regulator/RegulatorTechnicalDetails.jsx";
import RegulatorUserManual from "./components/regulator/RegulatorUserManual.jsx";
import RegulatorGate from "./apps/regulator/RegulatorGate.jsx";

// Auth Context
import { AuthProvider } from "./components/router/authContext.jsx";
import { ProtectedRoute } from "./components/router/auth/ProtectedRoute.jsx";
import { PublicRoute } from "./components/router/auth/PublicRoute.jsx";
import FleetInternalGate from "./components/router/auth/FleetInternalGate.jsx";
import InternalOpsGate from "./components/router/auth/InternalOpsGate.jsx";
import EvDemoGate from "./components/router/auth/EvDemoGate.jsx";
import InactivityWarningModal from "./components/router/InactivityWarningModal.jsx";
import EvChargingSimPage from "./demos/ev-charging-sim/EvChargingSimPage";

// Parcel Context
import { ParcelProvider } from "./contexts/ParcelContext.jsx";

// Cookie Context
import { CookieProvider } from "./contexts/CookieContext.jsx";
import CookieBanner from "./components/general/CookieBanner.jsx";
import CookieSettingsModal from "./components/general/CookieSettingsModal.jsx";
import MaintenanceBanner from "./components/general/MaintenanceBanner.jsx";

// Tutorial
import { TutorialProvider } from "./contexts/TutorialContext.jsx";
import TutorialOverlay from "./components/tutorial/TutorialOverlay.jsx";

// JS Imports
import { Suspense, lazy } from "react";
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import { PageTracker, GADebugger } from "./utils/analytics";
import { GoogleMapsProvider } from "./contexts/GoogleMapsContext";
import { OptimizationRunProvider } from "./contexts/OptimizationRunContext";
import { UtilityMdhdAnalysisProvider } from "./contexts/UtilityMdhdAnalysisContext";
import { MaintenanceProvider } from "./contexts/MaintenanceContext.jsx";

export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
});

const Inputs = lazy(() => import("./apps/fleet_planning/inputs.js"));
const AnalyticsCaseListPage = lazy(() => import("./apps/fleet_planning/AnalyticsCaseListPage.js"));
const AnalyticsCaseDetailPage = lazy(() => import("./apps/fleet_planning/AnalyticsCaseDetailPage.js"));
const FleetLatestResultRedirect = lazy(() => import("./apps/fleet_planning/FleetLatestResultRedirect.js"));
const FleetOperatingPreviewPage = lazy(() => import("./apps/fleet_planning/FleetOperatingPreviewPage.jsx"));
const FleetLlmModelSelectionPage = lazy(() => import("./apps/fleet_planning/FleetLlmModelSelectionPage.jsx"));
const Subscription = lazy(() => import("./main-site-pages/Subscription.jsx"));

const lazyRouteFallback = (
  <div className="p-6 text-sm text-gray-500 font-ui">Loading page...</div>
);


const withSuspense = (element) => (
  <Suspense fallback={lazyRouteFallback}>
    {element}
  </Suspense>
);

function App() {
  return (
    <AuthProvider>
      <MaintenanceProvider>
        <CookieProvider>
          <TutorialProvider>
          <MaintenanceBanner />
          <InactivityWarningModal />
          <CookieBanner />
          <CookieSettingsModal />
          <TutorialOverlay />
          <GoogleMapsProvider>
            <Router>
              <PageTracker />
              <GADebugger />
              <OptimizationRunProvider>
            <Routes>
            {/* Public routes with MainLayout */}
            <Route element={<PublicRoute restricted={true} />}>
              <Route element={<MainLayout />}>
                <Route path="/" element={<HomePage />} />
                <Route path="/solutions" element={<Navigate to="/#solutions" replace />} />
                <Route path="/fleet-planning-basic" element={<BasicCalculator />} />
                <Route path="/basic" element={<BasicCalculator />} />
                <Route path="/southcoast" element={<FreeTrialRegistration />} />
                <Route path="/scaqmd-promotion" element={<Navigate to="/southcoast" replace />} />
                <Route path="/products" element={<Products />} />
                <Route path="/solutions/fleet" element={<FleetOwners />} />
                <Route path="/solutions/charging" element={<ChargerDevelopers />} />
                <Route path="/solutions/regulator" element={<Regulators />} />
                <Route path="/fleet-owners" element={<Navigate to="/solutions/fleet" replace />} />
                <Route path="/charging-station-developers" element={<Navigate to="/solutions/charging" replace />} />
                <Route path="/regulators" element={<Navigate to="/solutions/regulator" replace />} />
                <Route path="/utilities" element={<Utilities />} />
              </Route>
            </Route>

            {/* Standalone public routes */}
            <Route element={<PublicRoute />}>
              <Route element={<MainLayout />}>
                <Route path="/subscription" element={withSuspense(<Subscription />)} />
                <Route path="/subscription/onboarding" element={<SubscriptionOnboarding />} />
                <Route path="/onboarding" element={<SubscriptionOnboarding />} />
                <Route path="/confirmation" element={<SubscriptionConfirmation />} />
                <Route path="/construction" element={<UnderConstruction />} />
                <Route path="/2026act" element={<ACT2026Registration />} />
                <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
                <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                <Route path="/resources" element={<Resources />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/news/gridplan" element={<GridPlanPlanArticle />} />
              </Route>
              <Route path="/login" element={<LoginPortal />} />
              <Route path="/logo-preview" element={<LogoPreview />} />
              <Route path="/logo-preview-round-2" element={<LogoPreviewRound2 />} />
              <Route path="/login/:token" element={<ACTFreeTrialRedirect />} />
              <Route path="/reset-password/:token" element={<ResetPassword />} />
              <Route path="*" element={<NotFoundPage />} />
            </Route>

            {/* Verification route - standalone */}
            <Route path="/verify-email/:token" element={<EmailVerificationPage />} />

            {/* Protected routes - only for authenticated users */}
            <Route element={<ProtectedRoute />}>
              {/* Pages accessible to logged in users, separate from marketing pages */}
              <Route path="/profile" element={<Profile />} />
              <Route path="/home" element={<LoginLanding />} />
              <Route
                path="/demo/ev-charging-sim"
                element={
                  <EvDemoGate>
                    <EvChargingSimPage />
                  </EvDemoGate>
                }
              />
              {/* Fleet Planning */}
              <Route path="/fleet" element={<AppLayout navConfig={fleetNavConfig} />}>
                <Route path="dashboard" element={<FleetPlanningDashboard />} />
                <Route
                  path="inputs"
                  element={withSuspense(<Inputs />)}
                />
                <Route path="analytics">
                  <Route
                    index
                    element={withSuspense(<AnalyticsCaseListPage />)}
                  />
                  <Route
                    path="latest"
                    element={withSuspense(<FleetLatestResultRedirect />)}
                  />
                  <Route
                    path="cases/:caseRef"
                    element={withSuspense(<AnalyticsCaseDetailPage />)}
                  />
                  <Route path="*" element={<Navigate to="/fleet/analytics" replace />} />
                </Route>
                <Route path="manual" element={<UserManual />} />
                <Route path="technical-details" element={<TechnicalDetails />} />
                <Route path="changelog" element={<ChangelogPage changelog={fleetChangelog} />} />
                <Route
                  path="internal/llm-models"
                  element={
                    <FleetInternalGate>
                      <Suspense fallback={lazyRouteFallback}>
                        <FleetLlmModelSelectionPage />
                      </Suspense>
                    </FleetInternalGate>
                  }
                />
                <Route
                  path="internal/preview"
                  element={
                    <FleetInternalGate>
                      <Suspense fallback={lazyRouteFallback}>
                        <FleetOperatingPreviewPage />
                      </Suspense>
                    </FleetInternalGate>
                  }
                />
              </Route>

              <Route path="/sage" element={<AppLayout navConfig={sageNavConfig} defaultCollapsed />}>
                <Route path="map" element={<SageMapPage />} />
              </Route>

              {/* Charger Planning */}
              <Route path="/charger" element={
                <ParcelProvider>
                  <AppLayout navConfig={chargerNavConfig} />
                </ParcelProvider>
                }>
                <Route path="dashboard" element={<ChargerPlanningDashboard />} />
                <Route path="browse" element={<ChargerMapView />} />
                <Route path="compare" element={<ChargerTableView />} />
                <Route path="manual" element={<ChargerUserManual />} />
                <Route path="technical-details" element={<ChargerTechnicalDetails />} />
                <Route path="changelog" element={<ChangelogPage changelog={chargerChangelog} />} />
              </Route>

              {/* Published forecast: public page, same shell as production, no GridPlan sidebar */}
              <Route element={<PublishedForecastLayout />}>
                <Route path="/utility/ca-statewide" element={<CaStatewiseCasePage />} />
                <Route
                  path="/utility/ca-statewide/technical-details"
                  element={<CaStatewideTechnicalDetails />}
                />
              </Route>

              {/* Utility Planning */}
              <Route
                path="/utility"
                element={
                  <UtilityMdhdAnalysisProvider>
                    <AppLayout navConfig={utilityNavConfig} />
                  </UtilityMdhdAnalysisProvider>
                }
              >
                <Route path="select" element={<StateUtilitySelector />} />
                <Route path="dashboard" element={<UtilityPlanningDashboard />} />
                <Route path="workflow" element={<UtilityWorkflow />} />
                <Route path="workflow/inputs/rate-plan" element={<RatePlanInputPage />} />
                <Route path="workflow/inputs/managed-charging" element={<ManagedChargingInputPage />} />
                <Route path="workflow/inputs/vehicle-pricing" element={<VehiclePricingInputPage />} />
                <Route path="workflow/inputs/policy" element={<PolicyInputPage />} />
                <Route path="workflow/inputs/charging-infra" element={<ChargingInfraInputPage />} />
                <Route path="workflow/inputs/season-weather" element={<SeasonWeatherInputPage />} />
                <Route path="workflow/inputs/demographics" element={<DemographicsInputPage />} />
                <Route path="workflow/inputs/travel-survey" element={<TravelSurveyInputPage />} />
                <Route path="workflow/mdhd/inputs/rate-plan" element={<RatePlanInputPage />} />
                <Route path="workflow/mdhd/inputs/managed-charging" element={<ManagedChargingInputPage />} />
                <Route path="workflow/mdhd/inputs/policy" element={<PolicyInputPage />} />
                <Route path="workflow/mdhd/inputs/charging-infra" element={<ChargingInfraInputPage />} />
                <Route path="workflow/mdhd/inputs/season-weather" element={<SeasonWeatherInputPage />} />
                <Route path="workflow/mdhd/inputs/demographics" element={<DemographicsInputPage />} />
                <Route path="workflow/mdhd/inputs/travel-survey" element={<TravelSurveyInputPage />} />
                <Route path="workflow/mdhd/inputs/vehicle-configuration" element={<VehicleConfigurationInputPage />} />
                <Route path="workflow/mdhd/inputs/ev-charging-behavior" element={<EvChargingBehaviorInputPage />} />
                <Route path="workflow/system-models/mdhd/ev-charging-behavior" element={<EvChargingBehaviorInputPage />} />
                <Route path="workflow/mdhd/simulation" element={<UtilityVehicleSimulation />} />
                <Route path="workflow/system-models/passenger-ev/adoption-trend" element={<PassengerEvAdoptionTrendPage />} />
                <Route path="workflow/system-models/passenger-ev/adoption-trend/zcta/:zcta" element={<PassengerEvZctaAdoptionTrendPage />} />
                <Route path="workflow/system-models/mdhd/adoption-trend" element={<MdhdEvAdoptionTrendPage />} />
                <Route path="scenarios">
                  <Route index element={<UtilityScenarioCaseListPage />} />
                  <Route path="latest" element={<UtilityLatestResultRedirect />} />
                  <Route path="cases/:caseId" element={<UtilityScenarioCaseDetailPage />} />
                </Route>
                <Route path="scenario" element={<UtilityScenarioStudy />} />
                <Route path="ca-transit" element={<CaTransitCasePage />} />
                <Route path="compare" element={<UtilityTableView />} />
                <Route path="vehicle-simulation" element={<Navigate to="/utility/workflow/mdhd/simulation" replace />} />
                <Route path="planning" element={<UtilityProactivePlanning />} />
                <Route path="changelog" element={<ChangelogPage changelog={utilityChangelog} />} />
              </Route>

              {/* Data Hub */}
              <Route path="/data" element={<AppLayout navConfig={dataHubNavConfig} />}>
                <Route index element={<DataHubHome />} />
                <Route path="rates" element={<RateListPage />} />
                <Route path="rates/:rateId" element={<RateDetailPage />} />
                <Route path="territories" element={<TerritoryMapView />} />
                <Route path="charging-stations" element={<ChargingStationMapView />} />
                <Route path="vehicles" element={<VehicleModelListPage />} />
                <Route path="changelog" element={<ChangelogPage changelog={dataHubChangelog} />} />
              </Route>

              {/* Internal Ops */}
              <Route element={<InternalOpsGate />}>
                <Route path="/internal" element={<AppLayout navConfig={internalOpsNavConfig} />}>
                  <Route index element={<Navigate to="/internal/database" replace />} />
                  <Route path="users" element={<InternalOpsUsers />} />
                  <Route path="users/:userId" element={<InternalOpsUserDetail />} />
                  <Route path="api-usage" element={<InternalOpsApiUsage />} />
                  <Route path="api-usage/:appLabel/parcels" element={<InternalOpsParcelPopularity />} />
                  <Route path="api-usage/:appLabel" element={<InternalOpsApiUsageApp />} />
                  <Route path="api-usage/:appLabel/endpoint" element={<InternalOpsApiUsageEndpoint />} />
                  <Route path="database" element={<InternalOpsDatabase />} />
                  <Route path="database/:appLabel" element={<InternalOpsDatabaseApp />} />
                  <Route path="database/:appLabel/:modelName" element={<InternalOpsDatabaseTable />} />
                  <Route path="traffic" element={<InternalOpsTraffic />} />
                  <Route path="sign-ins" element={<InternalOpsLoginMap />} />
                </Route>
              </Route>

              {/* Regulator (dev-only) */}
              <Route path="/regulator" element={<RegulatorGate />}>
                <Route element={<AppLayout navConfig={regulatorNavConfig} />}>
                  <Route index element={<Navigate to="/regulator/map" replace />} />
                  <Route path="map" element={<RegulatorMapView />} />
                  <Route path="table" element={<RegulatorTableView />} />
                  <Route path="manual" element={<RegulatorUserManual />} />
                  <Route path="technical-details" element={<RegulatorTechnicalDetails />} />
                  <Route path="changelog" element={<ChangelogPage changelog={regulatorChangelog} />} />
                </Route>
              </Route>
            </Route>
              </Routes>
              </OptimizationRunProvider>
            </Router>
          </GoogleMapsProvider>
          </TutorialProvider>
        </CookieProvider>
      </MaintenanceProvider>
    </AuthProvider>
  );
}

export default App;
